<template>
  <BInputWithValidation
    :id="`prelimInput_${field.identifier}`"
    v-if="visible"
    :rules="{ required: true, regex: /^[0-9 ]*$/ }"
    :label="field.label"
    :mask="field.mask"
    :validation="field.validation"
    v-model="selectedValue"
  />
</template>

<script>
export default {
  name: "LeasingPrescoreInputQuestion",
  components: {
    BInputWithValidation: () => import("@/components/BInputWithValidation.vue"),
  },
  props: {
    field: {
      type: Object,
      required: true,
    },
    visible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      selectedValue: "",
    };
  },
  mounted() {
    this.selectedValue =
      this.$store.getters["leasingPrescore/answer"](this.field.identifier) ||
      null;
    this.$watch("selectedValue", this.valueWatcher);
  },
  methods: {
    valueWatcher() {
      this.$store.dispatch("leasingPrescore/addData", {
        question: this.field.identifier,
        answer: this.selectedValue,
      });
    },
  },
};
</script>

<style scoped></style>
